import { useEffect, useState } from 'react';
import { getIpeWorkspaceMode } from '@/utils/api';

/**
 * 订阅工作台个人/团队模式；切换时与 localStorage、X-IPE-Workspace 请求头保持同步。
 */
export function useIpeWorkspaceMode() {
  const [mode, setMode] = useState(() => getIpeWorkspaceMode());

  useEffect(() => {
    const sync = (ev) => {
      const next = ev?.detail?.mode;
      if (next === 'personal' || next === 'team') {
        setMode(next);
        return;
      }
      setMode(getIpeWorkspaceMode());
    };
    window.addEventListener('ipe:workspace-mode-changed', sync);
    window.addEventListener('ipe-workspace-mode-changed', sync);
    // refresh 不改 mode 语义，仅兜底读 localStorage（团队管理等场景）
    window.addEventListener('ipe:workspace-refresh', sync);
    return () => {
      window.removeEventListener('ipe:workspace-mode-changed', sync);
      window.removeEventListener('ipe-workspace-mode-changed', sync);
      window.removeEventListener('ipe:workspace-refresh', sync);
    };
  }, []);

  return mode;
}
